var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{class:["avatar__img is-fullwidth" ].concat( _vm.imgClass),attrs:{"src":_vm.url,"alt":_vm.alt},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }